module.exports = __webpack_public_path__ + "static/media/s_v8_t7.1f5b1b5d.mp3";